import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b356abf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "additional-items-bg"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "한국쪽 통관 요구 주의 사항 ! 꼭 체크하세요 !", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 한국쪽 해관 요구에 따라 방직품이면 원산지 표시를 봉제해야 부가항목에 워싱라벨 제작/ 봉제 서비스를 선택하세요! ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 잡화이면 출고할때 상품 개당 made in china 스티커를 붙여야 돼서 스티커를 개당 단위로 잘 붙일수 있거나 스티커를 벗겨지지 않도록 주문할때 opp봉투를 추가하고 나서 made in china 스티커를 붙이는 방식을 추천합니다! ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 동의하시면 주문할때 'opp 투명 포장' 서비스를 선택하시기 바랍니다! ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 동의 안 하시면 검사위험 부담하셔야 됩니다! ")
const _hoisted_12 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]

import { ref, computed, watch, onMounted } from 'vue'
import { useSite, isJA, useRtAffix, isD2C, isKO } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['layout', 'data', 'checkMap', 'mode'],
  emits: ['update', 'calc'],
  setup(__props, { emit }) {

const props = __props



const showAdditional = ref(1)
const additional = require('@/assets/image/additional.png')
const oparrows = require('@/assets/image/oparrows.png')

const isAdditional = () => {
  const additionalValue = localStorage.getItem('Additional')
  if (additionalValue) {
    showAdditional.value = 0
  } else {
    showAdditional.value = 1
  }
}

const setAdditional = () => {
  showAdditional.value = showAdditional.value === 1 ? 0 : 1
  localStorage.setItem('Additional', showAdditional.value + '')
}

onMounted(() => {
  if (!isD2C() && isKO()) {
    isAdditional()
  }
})


return (_ctx: any,_cache: any) => {
  return (_unref(isKO)()&&!_unref(isD2C)())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: _unref(additional),
            alt: ""
          }, null, 8, _hoisted_2),
          _hoisted_3,
          _createElementVNode("span", {
            class: "operation",
            onClick: setAdditional
          }, [
            _createTextVNode(_toDisplayString(showAdditional.value == 1 ? '접기' : '더 보기'), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["arrow", showAdditional.value == 1 ? 'up' : 'down'])
            }, [
              _createElementVNode("img", {
                src: _unref(oparrows),
                alt: ""
              }, null, 8, _hoisted_4)
            ], 2)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["txt", showAdditional.value == 1 ? 'show' : 'hidden'])
        }, _hoisted_12, 2)
      ]))
    : _createCommentVNode("", true)
}
}

})